module.exports = __webpack_public_path__ + "img/c931ac3.png";